<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="usuarios"
            :search="search"
            sort-by="noFactura"
            sort-desc="noFactura"
            class="elevation-1 pa-1"

            >
            <template v-slot:item.saldo="{ item }"> 
				{{ item.precio -item.pago}}
			</template>
			<template v-slot:item.estadoFacturacion="{ item }"> 
				<v-chip :color="getColor(item.estadoFacturacion)" :text-color="getColorText(item.estadoFacturacion)">• {{ item.estadoFacturacion }} </v-chip>
			</template>

            <template v-slot:top>
                <v-row class="pa-2">
                    <v-col cols="12" lg="3" md="5" sm="8" xs="12" >
                        <v-card-actions class="rounded-xl light-blue lighten-5 mx-5">
							<v-btn  fab="" color="error" class="mx-1" @click="crearPDF()">PDF</v-btn>
                                <vue-excel-xlsx
                                    :data="usuarios"
                                    :columns="columns"
                                    :filename="'Reporte de Reservas '+$store.state.usuario.localidad"
                                    :sheetname="'Reservas'"
                                    >
                                    <v-btn fab="" color="success">  <v-icon large="">mdi-file-excel </v-icon> </v-btn>
                                </vue-excel-xlsx> 
                            <v-card-title>Reservas</v-card-title>
                        </v-card-actions>
						 </v-col>
                    <v-col cols="12" lg="4" md="7" sm="4" xs="12">    
                        <v-text-field v-model="search"  append-icon="mdi-magnify"
                         label="Buscar" single-line hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="2" md="6" sm="6" xs="6">
                        <v-text-field height="10px" v-model="start" type="date" label="Fecha inicial"></v-text-field>
                        <v-text-field height="10px" v-model="end"  type="date" label="Fecha final"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="2" md="5" sm="5" xs="5">
						<v-select height="15px" label="Filtrar por:" :items="Tipos" v-model="TipoFiltro" /> 
                    </v-col>
                    <v-col cols="12" lg="1" md="1" sm="1" xs="1">
                        <v-btn :loading="loading" color="info" @click="listarFechas()" fab > <v-icon fab> mdi-cloud-search </v-icon> </v-btn>
					</v-col>
                </v-row>
               
            </template>

				<template v-slot:no-data>
						<v-data-table item-key="name" class="elevation-1" loading loading-text="Por favor seleccione el rango de fechas que desea visualizar"></v-data-table>
						<v-btn color="primary" @click="initialize">Reiniciar</v-btn>
				</template>
			</v-data-table>
        <template class="pa-3">
            <v-snackbar
                    v-model="snackbar" top vertical="" :timeout="5000"
                    >
                    {{ Mensaje }}
                    <v-btn
                    color="info"
                    text
                    @click="snackbar = false"
                    >
                    Cerrar
                    </v-btn>
            </v-snackbar>
            
            <v-row flat color="white"  class="pa-2">
                    <v-select prepend-inner-icon="mdi-cash-100" outlined=""  @change="FiltrarProveedor()" :items="Proveedores" v-model="proveedor" label="Filtrar por Proveedor"> </v-select>
                    <v-select prepend-inner-icon="mdi-contactless-payment-circle"  outlined="" class="mx-1" @change="FiltrarFamilia()" :items="familias" v-model="familia" label="Filtrar por Familia"> </v-select>
					<v-select  @change="listarFechas" :items="Localidades"  outlined label="Localidad" v-model="Localidad"> </v-select>
                   	<v-select class="mx-1" @change="FiltrarTour" outlined v-model="TourOperador" :items="TourOperadores" type="text" label="Tour Operador"></v-select> 
					<v-select class="mx-1" @change="FiltrarAgencia" outlined v-model="agencia" :items="Agencias" type="text" label="Agencia"></v-select>
					<v-select class="mx-1" @change="FiltrarEstado" outlined v-model="estado" :items="Estados" type="text" label="Estado"></v-select>
                    <v-btn :loading="loading" x-large dark color="#FF1744" class="btnLimpiarGrid mr-4 pa-2" id="espacioBoton" @click="select()">
                    <v-icon  large=""> mdi-delete </v-icon> Limpiar filtros </v-btn> 
            </v-row>
        </template>
    </div>
</template>

<script scoped>
import axios from 'axios'
import Chart from 'chart.js'
import jsPDF from 'jspdf'
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import html2canvas from 'html2canvas';
import QrcodeVue from 'qrcode.vue'

Vue.use(VueExcelXlsx);
  export default {
    data: () => ({
    mesesValores: null,
    nombreMeses: [],
    totalMeses: [],
    value: 'https://www.noah.cr',
    size: 100,
    dialog: false,
    familia: '',
    search: '',
    ClienteSeleccionado : '',
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    headers: [
	{ text: 'Facturación', value: 'estadoFacturacion' },
    { text: 'Cliente', value: 'name' },
    { text: 'Check In', value: 'start2'  },
    { text: 'Vendedor', value: 'vendedor'  },
	{ text: 'Cliente', value: 'cliente' },   
    { text: 'Fecha Salida', value: 'end2'  },
    { text: 'Servicio', value: 'category' },
    { text: 'Número', value: 'Telefono' },
    { text: 'Usuario', value: 'usuario' },
    { text: 'Fecha Registro', value: 'fecha' },   
	{ text: 'Agencia', value: 'agencia' }, 
	{ text: 'Tour Operador', value: 'tourOperador' }, 
	{ text: 'Precio', value: 'precio' }, 
	{ text: 'Anticipo', value: 'pago' }, 
	{ text: 'Saldo', value: 'saldo' }, 
	{ text: 'Personas', value: 'personas' }, 
	{ text: 'Estado', value: 'estado' }, 
    ],
    columns : [
		    { label: 'Cliente', field: 'name' },
			{ label: 'Check In', field: 'start2'  },
			{ label: 'Vendedor', field: 'vendedor'  },
			{ label: 'Cliente', field: 'cliente' },   
			{ label: 'Fecha Salida', field: 'end2'  },
			{ label: 'Servicio', field: 'category' },
			{ label: 'Número', field: 'Telefono' },
			{ label: 'Usuario', field: 'usuario' },
			{ label: 'Fecha Registro', field: 'fecha' },   
			{ label: 'Agencia', field: 'agencia' }, 
			{ label: 'Tour Operador', field: 'tourOperador' }, 
			{ label: 'Precio', field: 'precio' }, 
			{ label: 'Anticipo', field: 'pago' }, 
			{ label: 'Saldo', field: 'saldo' }, 
			{ label: 'Personas', field: 'personas' }, 
			{ label: 'Estado', field: 'estado' }, 
        ],
    usuarios: [],
    tipoDocumentos: [
        'FISICA',
        'JURIDICA',
        'EXTRANJERO',
    ],
    familias: [],
    Top10: [],
	end: '',
	start:'',
	TipoFiltro:[],
	Tipos:["In","Out"],
    DescTop: [],
	Localidades:[],
	Localidad :"",
    infoTop: [],
	estado: '',
	Estados: ["Check In","Check Out","In House","Bloqueado","CANCELLED","MODIFIED"],
	Agencias:[],
	TourOperadores:[],
	loading: true,
    Proveedores: [],
	TourOperador:'',
	agencia:'',
    proveedor: '',
    Mensaje: 'Seleccione un rango de fechas',
    snackbar: true,
    }),
    components: {
      QrcodeVue,
    },

    computed: {
    formTitle () {
            return this.editedIndex === -1 ? 'Nuevo usuario' : 'Actualizar usuario'
    },
	calcularUtilidad:function(){
        var resultado=0.0;
          for(var i=0;i<this.usuarios.length;i++){
			  resultado += this.usuarios[i].totalLinea - (this.usuarios[i].precioCompra * this.usuarios[i].cantidad) - this.usuarios[i].descuentos
          }
        
        return resultado.toFixed(2);
      },
	calcularTotal:function(){
        var resultado=0.0;
          for(var i=0;i<this.usuarios.length;i++){
			  resultado += this.usuarios[i].totalLinea - this.usuarios[i].descuentos
          }
        
        return resultado.toFixed(2);
      },
    },
    

    watch: {
      dialog (val) {
        val || this.close()
      },
      
    },


    methods: {
        select(){
			let me=this;
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/Reservas/Listar/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.usuarios=response.data;
				me.loading = false;
				me.TourOperador = '';
				me.agencia = '';
			}).catch(function(error){
				console.log(error);
			});
        },
		async SelectFichaProducto(){
			let me=this;
			this.Agencias = [];
			var Data=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/FichaProductos/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				Data=response.data;
				for(var i = 0; i < Data.length; ++i){
					if(Data[i].valor == "Agencia"){
						me.Agencias.push(Data[i].nombre);
					} else
					if(Data[i].valor == "Tour Operador"){
						me.TourOperadores.push(Data[i].nombre);
					}
				}
			})
		}, 
		getColor (mensajeRespuesta) {
			if (mensajeRespuesta == 'Pendiente') return 'indigo lighten-4'
			if(mensajeRespuesta == 'Facturado') return 'orange lighten-4'
			else  return 'light-green lighten-4'
		},
		getColorText (mensajeRespuesta) {
			if (mensajeRespuesta == 'Pendiente') return 'indigo darken-4'
			if(mensajeRespuesta == 'Facturado') return 'orange darken-4'
			else  return 'light-green darken-4'
		},
		selectLocalidad(){
                let me=this;
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion= {headers : header};
                axios.get('api/VentasXProductoes/ConsultaFechas/'+this.today+'/'+this.today+'/'+this.Localidad,configuracion).then(function(response){
                    //console.log(response);
                    me.usuarios=response.data;
                }).catch(function(error){
                    console.log(error);
                });
        },
        selectProveedores(){
                let me=this;
                let header={"Authorization" : "Bearer " };
                let configuracion= {headers : header};
                var proveedoresArray=[];
                axios.get('api/proveedores/Select/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
                    proveedoresArray=response.data;
                    proveedoresArray.map(function(x){
                        me.Proveedores.push(x.proveedor);
                    });
                }).catch(function(error){
                    console.log(error);
                });
            },
        selectFamilias(){
             let me=this;
          let header={"Authorization" : "Bearer " };
          let configuracion= {headers : header};
          var familiasArray=[];
          axios.get('api/Familias/Select/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
              familiasArray=response.data;
              familiasArray.map(function(x){
                  me.familias.push(x.nombre);
              });
          }).catch(function(error){
              console.log(error);
          });
        },
        FiltrarProveedor(){
            this.usuarios = this.usuarios.filter(e => e.proveedor == this.proveedor);
            this.snackbar = true;
            this.Mensaje = 'Filtro de Proeedor Seleccionado sobre rango de fecha listado'
        },
        FiltrarFamilia(){
            let amp = "";
            this.Datos = this.usuarios;
            this.usuarios = this.usuarios.filter(e => e.famlia == this.familia);
            this.snackbar = true;
            this.Mensaje = 'Filtro de Familia seleccionado sobre rango de fecha listado'
        },
		FiltrarTour(){
            let amp = "";
            this.Datos = this.usuarios;
            this.usuarios = this.usuarios.filter(e => e.tourOperador == this.TourOperador);
            this.snackbar = true;
            this.Mensaje = 'Filtro de Tour Operador seleccionado sobre rango de fecha listado'
        },
		FiltrarAgencia(){
            let amp = "";
            this.Datos = this.usuarios;
            this.usuarios = this.usuarios.filter(e => e.agencia == this.agencia);
            this.snackbar = true;
            this.Mensaje = 'Filtro de Agencia seleccionado sobre rango de fecha listado'
        },
		FiltrarEstado(){
            let amp = "";
            this.Datos = this.usuarios;
            this.usuarios = this.usuarios.filter(e => e.estado == this.estado);
            this.snackbar = true;
            this.Mensaje = 'Filtro de Estado seleccionado sobre rango de fecha listado'
        },
        FiltrarCliente2(){
            let amp = "";
            this.Datos = this.usuarios;
            this.usuarios = this.usuarios.filter(e => e.nombreReceptor == this.ClienteSeleccionado);
            this.snackbar = true;
            this.Mensaje = 'Filtro de vendedor seleccionado sobre rango de fecha listado'
        },
        FiltrarMoneda(){
            let amp = "";
            this.Datos = this.usuarios;
            amp = this.Datos.filter(e => e.moneda == this.familia);
            this.usuarios = amp;
            this.snackbar = true;
            this.Mensaje = 'Filtro Medio de Moneda Seleccionado sobre rango de fecha listado'
        },
		listarAsociadas(){
			var items = [];
			let me=this;
			me.Localidades.push(me.$store.state.usuario.localidad);
			this.Localidad = this.$store.state.usuario.localidad
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
				items=response.data;
				items.map(function(x){
					me.Localidades.push(x.localdiadAsociada);
				});
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
    	},
            verLocalidad(item){
            this.NombreLocalidad= item.nombre;
            this.CedulaLocalidad= item.cedulaJuridica;
            this.DireccionLocalidad= item.dirreccion;
            },
        crearPDF(){
           var columns = [
            {title: "Cliente", dataKey: "name"},
            {title: "Estado", dataKey: "estado"}, 
            {title: "Check In", dataKey: "start2"}, 
            {title: "Check Out", dataKey: "end2"},
            {title: "Total", dataKey: "precio"},
            {title: "Saldo", dataKey: "saldo"},
            {title: "Servicio", dataKey: "category"},
            ];
            var rows = [];

            this.usuarios.map(function(x){
                rows.push({name:x.name,estado:x.estado,start2:x.start2,end2:x.end2,precio:x.precio,saldo:x.precio - x.pago,category:x.category});
            });

            // Only pt supported (not mm or in)
            var doc = new jsPDF('p', 'pt');
            doc.autoTable(columns, rows, {
                margin: {top: 60},
                addPageContent: function(data) {
                    doc.text("Reporte Reservas", 40, 30);
                }
            });
            doc.save('ReporteReservas.pdf');
        },
        crearPDFFactura(){
            var fact = this.noFactura;
             var quotes = document.getElementById('factura');
                html2canvas(quotes).then(function (canvas) {
                    var imgData = canvas.toDataURL('https://i.ibb.co/7rj9fLf/the-one-blanco.jpg');
                    var imgWidth = 210;
                    var pageHeight = 285;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;
                    var doc = new jsPDF();
                    var position = 0;

                    doc.addImage(imgData, 'JPG', 0, position, imgWidth, imgHeight);                    
                    doc.save('ComprobanteVenta'+fact+'.pdf');
                });
        },
        listarFechas(){
			if(this.TipoFiltro == ''){
				 this.snackbar = true;
				this.Mensaje = 'Debe seleccionar una El tipo de filtro'
				return;

			}
            if(this.start == '' || this.end == ''){
                this.snackbar = true;
                this.Mensaje = 'Debe seleccionar una fecha inicial y final'
                return;
           }
		   if(this.TipoFiltro == 'In'){
				this.BuscarEntradas();
				return;
		   }else
		   this.BuscarSalidas();
            
        },
		BuscarEntradas(){
			this.snackbar = true;
			this.Mensaje = 'Buscando data en: '+this.Localidad;
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            axios.get('api/Reservas/ListarFechas/'+this.start+'/'+this.end+'/'+this.Localidad,configuracion).then(function(response){
                //console.log(response);
                me.usuarios=response.data;
            }).catch(function(error){
                console.log(error);
                me.Mensaje  = error;
                me.snackbar = true;
            });
		},
		BuscarSalidas(){
			this.snackbar = true;
			this.Mensaje = 'Buscando data en: '+this.Localidad;
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            axios.get('api/Reservas/ListarFechasSalidas/'+this.start+'/'+this.end+'/'+this.Localidad,configuracion).then(function(response){
                //console.log(response);
                me.usuarios=response.data;
            }).catch(function(error){
                console.log(error);
                me.Mensaje  = error;
                me.snackbar = true;
            });
		},

		close () {
			this.dialog = false;
			this.limpiar();
		},
    

      activarDesactivarMostrar(accion,item){
                this.adModal=1;
                this.adNombre=item.nombre;
                this.adId=item.idusuario;                
                if (accion==1){
                    this.adAccion=1;
                }
                else if (accion==2){
                    this.adAccion=2;
                }
                else{
                    this.adModal=0;
                }
            },
            activarDesactivarCerrar(){
                this.adModal=0;
            },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
  mounted(){
      this.select();
      this.selectFamilias();
      this.selectProveedores();
	  this.listarAsociadas();
	  this.SelectFichaProducto();
  }
  }

</script>
My CRUD